export default __webpack_public_path__ + "static/media/dot-menu.aea5024f.svg";